(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {
            $routeProvider
                .when('/login/account', {
                    templateUrl: require('./templates/account.html'),
                    resolve: {
                        loadSecurity: ['security', function (security) { return security.initialize() } ]
                    }
                })
                .when('/register', {
                    templateUrl: require('./templates/register.html'),
                })
                .when('/activate/:email', {
                    templateUrl: require('./templates/register-activate.html'),
                })
                .when('/token/:token', {
                    templateUrl: require('./templates/token.html'),
                })
                .when('/password/change/:token', {
                    template: '<div ng-controller="upp.plugins.login.ChangePasswordCtrl"></div>'
                })
        }]);

    upp.factory('accountStatusMessageHandler', [ 'translator',
        function (translator) {
            /**
             * Create a status handler to show success messages or error messages
             * @param $scope the current controller scope
             * @param scopeErrorVar the variable name to use in the scope as error
             * @param scopeOkVar
             * @constructor
             */
            function StatusMessageHandler($scope, scopeErrorVar, scopeOkVar) {
                this.$scope = $scope;
                this.scopeErrorVar = scopeErrorVar;
                this.scopeOkVar = scopeOkVar;
            }

            var showError = function (title, message) {
                var msg = "",
                    messageTypeOf = typeof message;

                if (message) {
                    if (messageTypeOf === 'object' && message.translatedErrorMessage) {
                        msg = message.translatedErrorMessage;
                    } else if (messageTypeOf === 'string') {
                        msg = translator.i18n(message);
                    }
                }
                this.$scope[this.scopeErrorVar] = {
                    title: translator.i18n(title),
                    msg: msg
                };
            };

            var hideError = function () {
                this.$scope[this.scopeErrorVar] = undefined;
            };

            var showOk = function () {
                this.$scope[this.scopeOkVar] = true;
            };

            var hideOk = function () {
                this.$scope[this.scopeOkVar] = false;
            };

            var create = (function () {

                var _bind = angular.bind;

                return function ($scope, error, ok) {
                    if (!$scope) {
                        throw new Error("$scope not found");
                    } else {
                        if (!(error || ok)) {
                            throw new Error("handlers not found");
                        } else {
                            var handler = new StatusMessageHandler($scope, error, ok);
                            if (error) {
                                handler.showError = _bind(handler, showError);
                                handler.hideError = _bind(handler, hideError);
                            }
                            if (ok) {
                                handler.showOk = _bind(handler, showOk);
                                handler.hideOk = _bind(handler, hideOk);
                            }
                            return handler;
                        }
                    }
                }
            })();

            return {
                create: create
            };

        }]);

    //Controller for Register
    upp.controller('upp.login.RegisterCtrl', ['$rootScope', '$scope', 'accountManagerService', 'config', 'appi', 'accountStatusMessageHandler', '$timeout',
        function ($rootScope, $scope, accountManagerService, config, appi, AccountStatusMessageHandler, $timeout) {

            var errorHandler = AccountStatusMessageHandler.create($scope, 'registerError');

            $scope.updateRegisterInfo = function(data) {
                Object.assign($scope, {
                    email: data.email,
                    password: data.password,
                    name: data.name,
                    surname: data.surname,
                    customerFields: data.fields,
                });
            }

            $scope.register = function (isFormValid) {
                if (isFormValid) {
                    appi.ui.showPageLoadingMsg();
                    accountManagerService.register($scope.email, $scope.password, $scope.name, $scope.surname, $scope.customerFields)
                        .then(function () {
                            appi.location.path("/activate/" + $scope.email);
                            appi.ui.hidePageLoadingMsg();
                        })
                        .catch(function (err) {
                            errorHandler.showError("LOGIN.REGISTER.ERR.SERVER", err.data);
                            $scope.submitted = false;
                            appi.ui.hidePageLoadingMsg();
                        });
                } else {
                    $scope.submitted = true;
                    errorHandler.showError("LOGIN.ERR.VALIDATION", "LOGIN.ERR.VALIDATION.MSG");
                }
            };

            $scope.termsHref = '#';
            config.getWebAppURL().then(function(url) {
                $scope.termsHref = url + "/#!/about/policy";
            });

            // TODO change this title for the customeraccount module name
            appi.ui.changeActualOption({i18n: 'LOGIN.REGISTER', navbarKey: 'register'});

            $timeout(function () {
                $rootScope.hidePageLoadingMsg();
            }, 1000);
        }]);


    upp.controller('upp.login.ActivateCtrl', ['$rootScope', '$scope', 'accountManagerService', '$routeParams', 'appi', 'accountStatusMessageHandler', '$timeout',
        function ($rootScope, $scope, accountManagerService, $routeParams, appi, AccountStatusMessageHandler, $timeout) {

            var errorHandler = AccountStatusMessageHandler.create($scope, 'registerError');

            appi.ui.changeActualOption({i18n: 'LOGIN.REGISTER', navbarKey: 'register'});

            $scope.resendActivation = function() {
                appi.ui.showPageLoadingMsg();
                accountManagerService.resendActivation($routeParams.email)
                    .then(function () {
                        // show message
                        appi.ui.hidePageLoadingMsg();
                        errorHandler.hideError();
                    })
                    .catch(function (err) {
                        errorHandler.showError("LOGIN.RESEND.ACTIVATE.ERR.SERVER", err.data);
                        appi.ui.hidePageLoadingMsg();
                    });
            };

            $scope.activate = function (isFormValid) {
                if (isFormValid) {
                    var code = $scope.number1 + "" + $scope.number2 + "" + $scope.number3 + "" + $scope.number4;
                    appi.ui.showPageLoadingMsg();
                    accountManagerService.activate($routeParams.email, code)
                        .then(function (token) {
                            appi.location.path("/token/" + token);
                            appi.ui.hidePageLoadingMsg();
                        })
                        .catch(function (err) {
                            errorHandler.showError("LOGIN.ACTIVATE.ERR.SERVER", err.data);
                            $scope.submitted = false;
                            appi.ui.hidePageLoadingMsg();
                        });
                } else {
                    $scope.submitted = true;
                    errorHandler.showError("LOGIN.ERR.VALIDATION", "LOGIN.ERR.VALIDATION.MSG");
                }
            };

            $timeout(function () {
                $rootScope.hidePageLoadingMsg();
            }, 1000);
        }]);

    //Controller for Account
    upp.controller('upp.login.AccountCtrl', ['$scope', 'accountManagerService', 'security', 'appi',
        'accountStatusMessageHandler', 'ordersService', 'translator',
        function ($scope, accountManagerService, security, appi, AccountStatusMessageHandler, ordersService, translator) {
            var statusMessageHandler = AccountStatusMessageHandler.create($scope, 'updateError', 'updateOk');

            $scope.updateAccountInfo = function(data) {
                Object.assign($scope, {
                    email: data.email,
                    password: data.password,
                    name: data.name,
                    surname: data.surname,
                    customerFields: data.fields,
                });
            }

            var updateAccount = function (isFormValid) {
                statusMessageHandler.hideOk();
                statusMessageHandler.hideError();

                if (isFormValid) {
                    appi.ui.showPageLoadingMsg();
                    accountManagerService.update($scope.password, $scope.name, $scope.surname, $scope.customerFields)
                        .then(function (data) {
                            statusMessageHandler.showOk();
                            appi.ui.hidePageLoadingMsg();
                        })
                        .catch(function (err) {
                            statusMessageHandler.showError("LOGIN.ACCOUNT.ERR.SERVER", err);
                            $scope.submitted = false;
                            appi.ui.hidePageLoadingMsg();

                        });
                } else {
                    $scope.submitted = true;
                    statusMessageHandler.showError("LOGIN.ERR.VALIDATION", "LOGIN.ERR.VALIDATION.MSG");
                }
            };

            var deleteAccount = (function () {
                var showModal = appi.ui.modalMessage;

                var showModal1 = function () {
                    showModal({
                        title: 'LOGIN.ACCOUNT.DELETE.MODAL.TITLE',
                        message: "LOGIN.ACCOUNT.DELETE.MODAL1.MSG",
                        closeButton: {
                            text: "CANCEL"
                        },
                        confirmButton: {
                            text: "LOGIN.ACCOUNT.DELETE.MODAL.CONFIRM",
                            callback: confirmModal1
                        }
                    }).then(function(modal) {
                        modal.show();
                    })
                };

                var confirmModal1 = function () {
                    ordersService.hasPendingOrders()
                        .then(function (hasPendingOrders) {
                            if (hasPendingOrders) {
                                setTimeout(showModal2, 500); //FIXME: First modal lasts 1000 msecs to hide, so a timeout is needed to avoid second modal coupling first one
                            } else {
                                confirmDeleteAccount();
                            }

                        }, function () {
                            appi.ui.showNetworkError();
                        });

                };

                var showModal2 = function () {
                    showModal({
                        title: "LOGIN.ACCOUNT.DELETE.MODAL.TITLE",
                        message: "LOGIN.ACCOUNT.DELETE.MODAL2.MSG",
                        closeButton: {
                            text: "CANCEL"
                        },
                        confirmButton: {
                            text: "LOGIN.ACCOUNT.DELETE.MODAL.CONFIRM",
                            callback: confirmModal2
                        }
                    });
                };

                var confirmModal2 = function () {
                    confirmDeleteAccount();
                };

                var confirmDeleteAccount = function () {
                    accountManagerService.remove()
                        .then(function () {
                            security.logout();
                        }, function () {
                            appi.ui.showNetworkError();
                        })
                };

                return function () {
                    showModal1();
                }

            })();

            $scope.changePersonType = function (val) {
                $scope.personType = val;
            };

            security.securable({scope: $scope})
                .then(function () {
                    appi.ui.changeActualOption({i18n: 'LOGIN.ACCOUNT'});

                    appi.ui.showPageLoadingMsg();

                    accountManagerService.retrieve()
                        .then(function (user) {
                            $scope.update = updateAccount;
                            $scope.delete = deleteAccount;

                            appi.ui.hidePageLoadingMsg();

                        })
                        .catch(function () {
                            appi.ui.showNetworkError();
                        });
                });
        }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/plugins/login/account.js